<template>
  <div>
    <template
      v-if="
        !['pending', 'reviewing', 'cancelled', 'completed'].includes(
          afterMarketInfo.status
        )
      "
    >
      <div class="aftermarket-wrap">
        <div class="aftermarket-title">退货地址</div>
        <div class="aftermarket-content">
          <div class="shou">收</div>
          <div class="aftermarket-info">
            <div class="info">
              <span>{{ afterMarketInfo.return_username }}</span>
              <span class="phone">{{
                afterMarketInfo.return_phone_number
              }}</span>
            </div>
            <div class="address">
              {{ afterMarketInfo.return_address }}
            </div>
          </div>
          <svg-icon iconClass="copy" class="copy" @click="handleCopy" />
        </div>
        <div class="aftermarket-btn" @click="handleAfterMarket">
          {{ btnText }}
        </div>
      </div>
    </template>
    <template v-else>
      <div class="refund-status">
        <svg-icon :iconClass="icon" class="icon" /> {{ refundStatus }}
      </div>
    </template>
  </div>
</template>

<script>
import { defineComponent, computed } from "@vue/composition-api";
import copy from "copy-to-clipboard";
import Vue from "vue";

import { useRouter, useRoute } from "@/components/use/base";
import { REFUND_MATTER_STATUS } from "@/constants";

const vm = Vue.prototype;

export default defineComponent({
  props: ["afterMarketInfo"],
  setup(props) {
    const router = useRouter();
    const route = useRoute();
    const refundNumber = route.query.refundNumber;

    const btnText = computed(() => {
      const { return_tracking_number } = props.afterMarketInfo;
      return return_tracking_number ? return_tracking_number : "填写单号";
    });

    const refundStatus = computed(() => {
      return REFUND_MATTER_STATUS[props.afterMarketInfo.status];
    });

    const icon = computed(() => {
      const { status } = props.afterMarketInfo;
      if (["pending", "reviewing", "returning"].includes(status))
        return `pay-result-unpaid-gold`;
      if (["failed", "canceled", "refund"].includes(status))
        return `pay-result-fail-gold`;
      return `pay-result-success-gold`;
    });

    const handleCopy = () => {
      copy(
        `收件人：${props.afterMarketInfo.return_username}\n电话：${props.afterMarketInfo.return_phone_number}\n地址：${props.afterMarketInfo.return_address}`
      );
      vm.$toast("复制成功");
    };

    const handleAfterMarket = () => {
      if (props.afterMarketInfo.return_tracking_number) return;
      router.push(`/matterAfterMarketDetail?refundNumber=${refundNumber}`);
    };

    return {
      btnText,
      refundStatus,
      icon,
      handleAfterMarket,
      handleCopy,
    };
  },
});
</script>

<style lang="less" scoped>
.aftermarket-wrap {
  background-color: #fff;
  padding: 12px 12px 18px 12px;
  background: #ffffff;
  border-radius: 8px;
}

.aftermarket-title {
  font-weight: 500;
  font-size: 14px;
  color: #000000;
  line-height: 20px;
}

.aftermarket-content {
  display: flex;
  align-items: center;
  margin-top: 12px;

  .shou {
    width: 21px;
    height: 21px;
    background: #ff6430;
    border-radius: 4px;

    font-weight: 600;
    font-size: 12px;
    color: #ffffff;
    line-height: 21px;
    text-align: center;
    flex-shrink: 0;
  }

  .copy {
    flex-shrink: 0;
    width: 16px;
    height: 19px;
    margin-right: 6px;
  }
}

.aftermarket-info {
  flex: 1;
  margin-left: 8px;
  margin-right: 8px;

  .info {
    display: flex;
    font-weight: 500;
    font-size: 12px;
    color: #000000;
    line-height: 17px;

    .phone {
      margin-left: 12px;
    }
  }

  .address {
    font-weight: 400;
    font-size: 12px;
    color: #b4b4b4;
    line-height: 17px;
  }
}

.aftermarket-btn {
  margin-top: 19px;
  width: 316px;
  height: 29px;
  background: linear-gradient(115deg, #dfbd94 0%, #ffe8c8 100%), #6c3e0c;
  border-radius: 8px;

  font-weight: 500;
  font-size: 12px;
  color: #6c3e0c;
  line-height: 29px;
  text-align: center;
}

.refund-status {
  display: flex;
  align-items: center;
  font-weight: 400;
  font-size: 16px;
  color: #000000;

  background-color: #fff;
  padding: 12px;
  background: #ffffff;
  border-radius: 8px;

  .icon {
    margin-right: 6px;
    font-size: 24px;
  }
}
</style>
